/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { History } from './History';
import {
    HistoryFromJSON,
    HistoryFromJSONTyped,
    HistoryToJSON,
    HistoryToJSONTyped,
} from './History';

/**
 * 
 * @export
 * @interface SearchHistoryResponse
 */
export interface SearchHistoryResponse {
    /**
     * 
     * @type {Array<History>}
     * @memberof SearchHistoryResponse
     */
    data: Array<History>;
    /**
     * 
     * @type {Pagination}
     * @memberof SearchHistoryResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the SearchHistoryResponse interface.
 */
export function instanceOfSearchHistoryResponse(value: object): value is SearchHistoryResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function SearchHistoryResponseFromJSON(json: any): SearchHistoryResponse {
    return SearchHistoryResponseFromJSONTyped(json, false);
}

export function SearchHistoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchHistoryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(HistoryFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function SearchHistoryResponseToJSON(json: any): SearchHistoryResponse {
      return SearchHistoryResponseToJSONTyped(json, false);
  }

  export function SearchHistoryResponseToJSONTyped(value?: SearchHistoryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(HistoryToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

